// get data from api
export const GET_TARIFFS = 'GET_TARIFFS';
export const GET_TARIFF = 'GET_TARIFF';
export const GET_TARIFFS_FOR_PORTFOLIO = 'GET_TARIFFS_FOR_PORTFOLIO';

export const SET_TARIFFS = 'SET_TARIFFS';
export const SET_TARIFF = 'SET_TARIFF';

export const TARIFF_RESET_ALL = 'TARIFF_RESET_ALL';

export const TARIFF_ERROR = 'TARIFF_ERROR';
export const TARIFF_CLEAR_ERROR = 'TARIFF_CLEAR_ERROR';



